import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useState } from "react";

export interface UseDragAndDropColumnProps {
    MouseSensor?: {
        activationConstraint?: {
            distance?: number
        }
    }
    TouchSensor?: {
        activationConstraint?: {
            delay?: number,
            tolerance?: number
        }
    }
}

const useDragAndDropColumn = (props?: UseDragAndDropColumnProps) => {
    const [updatedData, setUpdatedData] = useState<any[]>([]);

    const handleDragEnd = (event: any) => {
        const { active, over } = event;
        
        if(active.id !== over.id) {
            const updateData = (data: any[]) => {
                const oldIndex = data.findIndex(item => item.id === active.id);
                const newIndex = data.findIndex(item => item.id === over.id);
                return arrayMove(data, oldIndex, newIndex);
            }

            const newData = updateData(updatedData);
            setUpdatedData(newData);
        }
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: {
                distance: props?.MouseSensor?.activationConstraint?.distance || 10
            }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: props?.TouchSensor?.activationConstraint?.delay || 250,
                tolerance: props?.TouchSensor?.activationConstraint?.tolerance || 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    return { updatedData, setUpdatedData, handleDragEnd, sensors };
}

export default useDragAndDropColumn;
